import { Button, Form, Input, Select } from 'antd';
import { useEffect } from 'react';
import type { AppSettings } from '@/types/settings';
import styles from '../Settings.module.scss';

interface WebsiteConfigTabProps {
  settings?: AppSettings;
  loading?: boolean;
  onSave: (values: AppSettings['website']) => Promise<void>;
}

const TIMEZONE_OPTIONS = [
  { label: 'Asia/Kolkata (IST)', value: 'Asia/Kolkata' },
  { label: 'UTC', value: 'UTC' },
  { label: 'Asia/Dubai', value: 'Asia/Dubai' },
  { label: 'Europe/London', value: 'Europe/London' },
];

const CURRENCY_OPTIONS = [
  { label: 'INR (₹)', value: 'INR' },
  { label: 'USD ($)', value: 'USD' },
  { label: 'EUR (€)', value: 'EUR' },
];

export function WebsiteConfigTab({ settings, loading, onSave }: WebsiteConfigTabProps) {
  const [form] = Form.useForm<AppSettings['website']>();

  useEffect(() => {
    if (settings?.website) {
      form.setFieldsValue(settings.website);
    }
  }, [form, settings?.website]);

  return (
    <div>
      <h2 className={styles.sectionTitle}>Website configuration</h2>
      <p className={styles.sectionDesc}>
        Manage your store name and regional preferences shown across the website.
      </p>

      <Form form={form} layout="vertical" disabled={loading} onFinish={onSave} requiredMark={false}>
        <div className={styles.formGrid}>
          <Form.Item
            label="Site name"
            name="siteName"
            rules={[{ required: true, message: 'Site name is required.' }]}
          >
            <Input placeholder="indiastatpublications" />
          </Form.Item>

          <Form.Item label="Currency" name="currency">
            <Select options={CURRENCY_OPTIONS} />
          </Form.Item>

          <Form.Item label="Timezone" name="timezone">
            <Select options={TIMEZONE_OPTIONS} showSearch optionFilterProp="label" />
          </Form.Item>
        </div>

        <div className={styles.actions}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save changes
          </Button>
        </div>
      </Form>
    </div>
  );
}
